<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet">
        <defs>
            <clipPath :id="`clip-path-${uniqueId}`">
                <rect id="Rectangle_226" data-name="Rectangle 226" width="48" height="48" rx="6" fill="#fff" />
            </clipPath>
        </defs>
        <g
            id="Icons_I_payment_transparent_ideal"
            data-name="Icons / I_payment_transparent_ideal"
            :clip-path="`url(#clip-path-${uniqueId})`">
            <g id="Group_1429" data-name="Group 1429">
                <path
                    id="Path_249"
                    data-name="Path 249"
                    d="M3.515,44.485C7.029,48,12.686,48,24,48s16.971,0,20.485-3.515S48,35.314,48,24,48,7.029,44.485,3.515,35.314,0,24,0,7.029,0,3.515,3.515,0,12.686,0,24,0,40.971,3.515,44.485Z"
                    fill="rgba(230,100,165,0)" />
                <path
                    id="Path_250"
                    data-name="Path 250"
                    d="M4.5,7.25V29.766A1.941,1.941,0,0,0,6.435,31.7H19.919C30.113,31.7,34.5,26.024,34.5,18.476S30.113,5.25,19.919,5.25H6.5A2.1,2.1,0,0,0,4.5,7.25Z"
                    transform="translate(4.5 5.25)"
                    fill="rgba(255,255,255,0)" />
                <path
                    id="Path_251"
                    data-name="Path 251"
                    d="M9.016,8.672V25.317h7.226c6.581,0,9.419-3.742,9.419-8.968,0-5.032-2.839-8.9-9.419-8.9h-6A1.185,1.185,0,0,0,9.016,8.672Z"
                    transform="translate(9.016 7.441)"
                    fill="#c06" />
                <path
                    id="Path_252"
                    data-name="Path 252"
                    d="M18.984,29.024H7.306a1.872,1.872,0,0,1-1.871-1.871V8.057A1.872,1.872,0,0,1,7.306,6.186H18.984c11.1,0,12.774,7.161,12.774,11.419C31.758,24.96,27.242,29.024,18.984,29.024ZM7.306,6.831A1.225,1.225,0,0,0,6.081,8.057v19.1a1.225,1.225,0,0,0,1.226,1.226H18.984c7.806,0,12.129-3.871,12.129-10.839,0-9.355-7.613-10.774-12.129-10.774Z"
                    transform="translate(5.435 6.186)" />
                <path
                    id="Path_253"
                    data-name="Path 253"
                    d="M11.177,10.8a2.317,2.317,0,0,1,.71.129,1.521,1.521,0,0,1,.581.387l.387.581a3.266,3.266,0,0,1,.129.839,2.4,2.4,0,0,1-.129.774,2.018,2.018,0,0,1-.322.645,1.407,1.407,0,0,1-.581.452,1.513,1.513,0,0,1-.774.129H9.435v-4Zm-.064,3.226a.819.819,0,0,0,.387-.064c.129-.065.194-.129.323-.194.065-.129.194-.194.194-.387a1.431,1.431,0,0,0,.065-.581,1.256,1.256,0,0,0-.065-.516,2.153,2.153,0,0,0-.194-.387.644.644,0,0,0-.323-.258,1.256,1.256,0,0,0-.516-.065h-.645v2.516Z"
                    transform="translate(9.435 10.734)"
                    fill="#fff" />
                <path
                    id="Path_254"
                    data-name="Path 254"
                    d="M14.5,10.8v.71H12.371v.9h1.935v.645H12.371v.968H14.5v.71H11.468v-4Z"
                    transform="translate(11.468 10.734)"
                    fill="#fff" />
                <path
                    id="Path_255"
                    data-name="Path 255"
                    d="M15.694,10.766l1.484,4h-.9l-.323-.9H14.468l-.323.9h-.9l1.484-4Zm.064,2.452-.516-1.484-.516,1.484Z"
                    transform="translate(13.242 10.766)"
                    fill="#fff" />
                <path
                    id="Path_256"
                    data-name="Path 256"
                    d="M16.371,10.8v3.226h1.935v.71H15.468v-4A4.581,4.581,0,0,0,16.371,10.8Z"
                    transform="translate(15.468 10.734)"
                    fill="#fff" />
                <path
                    id="Path_257"
                    data-name="Path 257"
                    d="M8.274,14.476a1.807,1.807,0,1,0-1.806-1.807A1.806,1.806,0,0,0,8.274,14.476Z"
                    transform="translate(6.468 10.863)" />
                <path
                    id="Path_258"
                    data-name="Path 258"
                    d="M9.468,19.573A2.754,2.754,0,0,1,6.694,16.8V14.6a1.419,1.419,0,1,1,2.839,0Z"
                    transform="translate(6.694 13.185)" />
            </g>
            <g id="Group_1430" data-name="Group 1430" style="mix-blend-mode: color; isolation: isolate">
                <path
                    id="Path_250-2"
                    data-name="Path 250"
                    d="M4.5,7.25V29.766A1.941,1.941,0,0,0,6.435,31.7H19.919C30.113,31.7,34.5,26.024,34.5,18.476S30.113,5.25,19.919,5.25H6.5A2.1,2.1,0,0,0,4.5,7.25Z"
                    transform="translate(4.5 5.25)"
                    fill="rgba(230,100,165,0)" />
                <path
                    id="Path_251-2"
                    data-name="Path 251"
                    d="M9.016,8.672V25.317h7.226c6.581,0,9.419-3.742,9.419-8.968,0-5.032-2.839-8.9-9.419-8.9h-6A1.185,1.185,0,0,0,9.016,8.672Z"
                    transform="translate(9.016 7.441)"
                    fill="#bfbca5" />
                <path
                    id="Path_252-2"
                    data-name="Path 252"
                    d="M18.984,29.024H7.306a1.872,1.872,0,0,1-1.871-1.871V8.057A1.872,1.872,0,0,1,7.306,6.186H18.984c11.1,0,12.774,7.161,12.774,11.419C31.758,24.96,27.242,29.024,18.984,29.024ZM7.306,6.831A1.225,1.225,0,0,0,6.081,8.057v19.1a1.225,1.225,0,0,0,1.226,1.226H18.984c7.806,0,12.129-3.871,12.129-10.839,0-9.355-7.613-10.774-12.129-10.774Z"
                    transform="translate(5.435 6.186)"
                    fill="#bfbca5" />
                <path
                    id="Path_253-2"
                    data-name="Path 253"
                    d="M11.177,10.8a2.317,2.317,0,0,1,.71.129,1.521,1.521,0,0,1,.581.387l.387.581a3.266,3.266,0,0,1,.129.839,2.4,2.4,0,0,1-.129.774,2.017,2.017,0,0,1-.322.645,1.407,1.407,0,0,1-.581.452,1.513,1.513,0,0,1-.774.129H9.435v-4Zm-.064,3.226a.819.819,0,0,0,.387-.064c.129-.065.194-.129.323-.194.065-.129.194-.194.194-.387a1.431,1.431,0,0,0,.065-.581,1.256,1.256,0,0,0-.065-.516,2.153,2.153,0,0,0-.194-.387.644.644,0,0,0-.323-.258,1.256,1.256,0,0,0-.516-.065h-.645v2.516Z"
                    transform="translate(9.435 10.734)"
                    fill="#bfbca5" />
                <path
                    id="Path_254-2"
                    data-name="Path 254"
                    d="M14.5,10.8v.71H12.371v.9h1.935v.645H12.371v.968H14.5v.71H11.468v-4Z"
                    transform="translate(11.468 10.734)"
                    fill="#bfbca5" />
                <path
                    id="Path_255-2"
                    data-name="Path 255"
                    d="M15.694,10.766l1.484,4h-.9l-.323-.9H14.468l-.323.9h-.9l1.484-4Zm.064,2.452-.516-1.484-.516,1.484Z"
                    transform="translate(13.242 10.766)"
                    fill="#bfbca5" />
                <path
                    id="Path_256-2"
                    data-name="Path 256"
                    d="M16.371,10.8v3.226h1.935v.71H15.468v-4A4.581,4.581,0,0,0,16.371,10.8Z"
                    transform="translate(15.468 10.734)"
                    fill="#bfbca5" />
                <path
                    id="Path_257-2"
                    data-name="Path 257"
                    d="M8.274,14.476a1.807,1.807,0,1,0-1.806-1.807A1.806,1.806,0,0,0,8.274,14.476Z"
                    transform="translate(6.468 10.863)"
                    fill="#bfbca5" />
                <path
                    id="Path_258-2"
                    data-name="Path 258"
                    d="M9.468,19.573A2.754,2.754,0,0,1,6.694,16.8V14.6a1.419,1.419,0,1,1,2.839,0Z"
                    transform="translate(6.694 13.186)"
                    fill="#bfbca5" />
            </g>
        </g>
    </svg>
</template>

<script lang="ts" setup>
    const uniqueId = useId();
</script>
